import { NotifyHelper } from "../../../helpers/toast";
import { eLoaiGioHocActionsObj } from "../../action-types/category/ILoaiGioHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiGioHocActions = {
    ...generateActions(eLoaiGioHocActionsObj, "LOAI_GIO_HOC"),
    ...generateActionForKey(eLoaiGioHocActionsObj, "LOAI_GIO_HOC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiGioHocActionsObj, "LOAI_GIO_HOC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiGioHocActionsObj, "LOAI_GIO_HOC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLoaiGioHocActionsObj, "LOAI_GIO_HOC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
